import './style.scss';

import classNames from 'classnames';
import ButtonC, { BUTTON_APPEARANCE } from 'components/ButtonC';
import Page from 'components/Page';
import RecommendedPreview from 'components/RecommendedPreview';
import { isLidlAppWebView } from 'helper/js/helper';
import { LanguageContext } from 'providers/Language';
import { forwardRef, memo, useContext } from 'react';

type PagePreviewProps = {
  className?: string;
  recommendedFlyer: ARecommendedFlyerItem;
  onFlyerClick?: () => void;
  onButtonClick?: () => void;
  isLastPage?: boolean;
  visible?: boolean;
  pageId: string;
  pageWidth?: number;
  pageHeight?: number;
  isAbTestVerticalScrollActive?: boolean;
};
const PagePreview = forwardRef<HTMLLIElement, PagePreviewProps>(
  (
    {
      recommendedFlyer,
      onFlyerClick = () => {},
      onButtonClick = () => {},
      className = '',
      isLastPage = false,
      visible = false,
      pageId,
      pageWidth,
      pageHeight,
      isAbTestVerticalScrollActive,
    }: PagePreviewProps,
    ref,
  ) => {
    const { t } = useContext(LanguageContext);

    const pageClasses = classNames({
      [className]: true,
      'page--preview': true,
    });

    const style =
      isAbTestVerticalScrollActive && pageWidth && pageHeight
        ? { width: pageWidth, height: pageHeight }
        : {};

    return (
      <Page
        ref={ref}
        className={pageClasses}
        isVisible={visible}
        isLastPage={isLastPage}
        pageId={pageId}
        type="preview"
        isAbTestVerticalScrollActive={isAbTestVerticalScrollActive}>
        <div className="preview" style={style}>
          <h2 className="preview_headline">{t('moreFlyersHeading')}</h2>
          <div className="preview__content">
            <RecommendedPreview {...recommendedFlyer} onClick={onFlyerClick} />
            {!isLidlAppWebView() && (
              <ButtonC
                fullwidth
                type={BUTTON_APPEARANCE.PRIMARY}
                label={t('moreFlyersTitleButton')}
                onClick={onButtonClick}
              />
            )}
          </div>
        </div>
      </Page>
    );
  },
);

export default memo(PagePreview);
